import React from 'react';
import clsx from 'clsx';
import formStyles from './table/AppTable.module.scss';

type OwnProps = {
  value: number;
  onClickHandler?: () => void;
  isActive?: boolean;
  className?: string;
  Svg?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  imageClassName?: string;
};

export const Step = (props: OwnProps) => {
  const { onClickHandler, value, isActive, className, Svg, imageClassName } =
    props;

  return (
    <div
      key={value}
      className={clsx(
        formStyles.pageText,
        formStyles.fitContent,
        formStyles.stepContainer,
        isActive && formStyles.activeOption,
        formStyles.step,
        className,
      )}
      onClick={onClickHandler}
    >
      {Svg ? <Svg className={imageClassName} /> : value}
    </div>
  );
};
